export default __webpack_public_path__ + "static/media/orange_minus.38b18f01.svg";